
import {
    FETCH_BACKGROUND_JOBS

} from '../actions/actionTypes';

const initialState = {
    backgroundJobs: []
};

export default (state = initialState, action) => {
    switch (action.type) {
      
        case FETCH_BACKGROUND_JOBS:
            return {
                ...state,
                backgroundJobs: [...action.payload]
            };
      
        default:
            return state;
    }
};
